import * as React from 'react';
import { cn } from '../../lib/utils.js';

const Textarea = React.forwardRef(({ className, ...props }, ref) => (
  <textarea
    className={cn(
      'flex min-h-24 w-full rounded-[var(--radius-element,var(--radius))] border border-[var(--color-border,var(--border))] bg-white px-3 py-2 text-sm text-[var(--color-text-primary,var(--foreground))] shadow-sm outline-none transition-colors placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-[var(--ring,var(--color-accent))] focus-visible:border-[var(--primary,var(--color-accent))] disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    ref={ref}
    data-astryx-textarea=""
    {...props}
  />
));

Textarea.displayName = 'Textarea';

export { Textarea };
